import React, { forwardRef } from 'react';

import {
  DrawerBottomSheet,
  DrawerBottomSheetContent,
  Modal,
  useLockBodyScroll,
} from '../..';
import { useToggleWithAnimation } from '../../hooks/useToggleWithAnimation';
import { useDrawer } from '../Drawer/useDrawer';
import { DEFAULT_SIZE } from '../Modal/constants';
import { useMediaQueries } from '../Provider/ResponsiveProvider';
import type { SystemModalProps } from './types';

// TODO: review it. Animation transitions hooks should not be inside SystemModal
const ModalWrapper = forwardRef<HTMLDivElement, SystemModalProps>(
  ({ open, onClose, modalSize, children, ...rest }, ref) => {
    const fadeToggleProps = useToggleWithAnimation({
      isOpen: open,
    });
    const { state } = fadeToggleProps;

    useLockBodyScroll({ state });

    return (
      <Modal
        ref={ref}
        onClose={onClose}
        size={modalSize}
        {...fadeToggleProps}
        {...rest}
      >
        {children}
      </Modal>
    );
  }
);

const DrawerWrapper = forwardRef<HTMLDivElement, SystemModalProps>(
  ({ open, onClose, children, ...rest }, ref) => {
    const { state, transitionDuration } = useDrawer({
      isOpen: open,
      transitionDuration: 300,
    });

    return (
      <DrawerBottomSheet
        ref={ref}
        state={state}
        transitionDuration={transitionDuration}
        onBackdropClick={onClose}
        {...rest}
      >
        <DrawerBottomSheetContent p="0">{children}</DrawerBottomSheetContent>
      </DrawerBottomSheet>
    );
  }
);

const SystemModal = forwardRef<HTMLDivElement, SystemModalProps>(
  ({ open, onClose, modalSize = DEFAULT_SIZE, children, ...rest }, ref) => {
    const { md } = useMediaQueries();

    return !md ? (
      <DrawerWrapper ref={ref} open={open} onClose={onClose} {...rest}>
        {children}
      </DrawerWrapper>
    ) : (
      <ModalWrapper
        ref={ref}
        open={open}
        onClose={onClose}
        modalSize={modalSize}
        {...rest}
      >
        {children}
      </ModalWrapper>
    );
  }
);

export default SystemModal;
